import React from 'react'
import { useTranslation } from 'react-i18next'
import { Input } from '@/components/ui/input'
import type { UrlModuleConfig } from '@/types/space-wizard'
import type { ModuleFieldComponentProps } from '@/types/space-wizard'

/**
 * The external link's only question: the address.
 *
 * "Open in a new tab or an iframe" and the iframe height used to sit here, but
 * the menu always opens the link in a new tab (`Sidebar.tsx`) and nothing read
 * either value, so they left in F-64 phase 1.
 */
export const UrlModuleFields: React.FC<ModuleFieldComponentProps<UrlModuleConfig>> = ({
  config,
  onChange,
  disabled = false
}) => {
  const { t } = useTranslation(['common'])

  return (
    <div className="space-y-2">
      <label htmlFor="externalUrl" className="text-sm font-medium text-gray-700">
        {t('common:spaces.externalUrl')} <span className="text-red-500">*</span>
      </label>
      <Input
        id="externalUrl"
        type="url"
        value={config.externalUrl || ''}
        onChange={(e) => onChange({ ...config, externalUrl: e.target.value })}
        placeholder={t('common:spaces.externalUrlPlaceholder')}
        disabled={disabled}
        required
      />
      <p className="text-xs text-gray-500">
        {t('common:spaces.externalUrlHint')}
      </p>
    </div>
  )
}
